
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#14173A] text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div className="md:col-span-1">
            <img 
              src="https://static.readdy.ai/image/d1c21e6c39d7a2648281721c1ab67111/342d8a2e59da040d2ac4d02356ab7467.png"
              alt="Horizon Safety"
              className="h-12 w-auto mb-4"
            />
            <p className="text-[#D4AF37] italic font-medium mb-3">Safety Built Forward.</p>
            <p className="text-gray-400 text-sm mb-4">Minnesota + Wisconsin</p>
            <div className="w-16 h-0.5 bg-[#D4AF37]"></div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-3">
              {[
                { name: 'Home', path: '/' },
                { name: 'Services', path: '/services' },
                { name: 'Forward System', path: '/forward-system' },
                { name: 'About', path: '/about' },
                { name: 'Contact', path: '/contact' }
              ].map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path}
                    className="text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-bold text-lg mb-4">Services</h3>
            <ul className="space-y-3">
              <li className="text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">
                Compliance Foundations
              </li>
              <li className="text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">
                Forward Safety System
              </li>
              <li className="text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">
                Leadership Support
              </li>
              <li className="text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">
                Fractional Safety Director
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-bold text-lg mb-4">Get In Touch</h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <i className="ri-mail-line text-[#D4AF37] text-xl flex-shrink-0 mt-1"></i>
                <div>
                  <p className="text-sm text-gray-400">Email</p>
                  <p className="text-white">horizonsafetyservices@gmail.com</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-phone-line text-[#D4AF37] text-xl flex-shrink-0 mt-1"></i>
                <div>
                  <p className="text-sm text-gray-400">Phone</p>
                  <p className="text-white">(651) 785-3638</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-line text-[#D4AF37] text-xl flex-shrink-0 mt-1"></i>
                <div>
                  <p className="text-sm text-gray-400">Service Area</p>
                  <p className="text-white">Minnesota + Wisconsin</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © 2025 Horizon Safety LLC. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm cursor-pointer"
              >
                Website Builder
              </a>
              <span className="text-gray-600">|</span>
              <span className="text-gray-400 text-sm">Privacy</span>
              <span className="text-gray-600">|</span>
              <span className="text-gray-400 text-sm">Terms</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
